jQuery(document).ready(function() {
 

    jQuery('.modlypop').each(function() {
        var $pop = jQuery(this);
        var showAfter = $pop.attr('data-showafter');
        var expiresAfter = $pop.attr('data-expiresafter');
        var modalRef = $pop.attr('data-pgmodal');
    
        if(Cookies.get('shownpop'+modalRef)) return;
     
        setTimeout(function() {
            $pop.fadeIn();
            if(expiresAfter == 'session') {
                Cookies.set('shownpop'+modalRef, '1');
            } else {
                Cookies.set('shownpop'+modalRef, '1', { expires: 30 })
            }
        }, showAfter * 1000);
    
        console.log(showAfter * 1000);
        
    });


    jQuery('.modlypop .personpop-bg, .modlypop .exitblocker').on('click', function() {
        jQuery(this).closest('.modlypop').fadeOut();
    });


    if(jQuery('.marquee').length) {
        jQuery('.marquee').each(function() {
            jQuery(this).marquee({
                //duration in milliseconds of the marquee
                duration: 30000,
                //gap in pixels between the tickers
                gap: 0,
                //time in milliseconds before the marquee will start animating
                delayBeforeStart: -30000,
                //'left' or 'right'
                direction: 'left',
                //true or false - should the marquee be duplicated to show an effect of continues flow
                duplicated: true
            });
        });
    }
    
    jQuery('a.pingcardinner[href=""]').on('click',function(e) {
        e.preventDefault();
    });


    console.log('fafqr3r2r32');


    jQuery(".propscroller").click(function() {
        jQuery('html, body').animate({
            scrollTop: jQuery(this).closest('.hero-headerbit').next().offset().top
        }, 0);
    });

    jQuery('.btn-transparent-arrows').append('<svg xmlns="http://www.w3.org/2000/svg" width="16.809" height="11.988" viewBox="0 0 16.809 11.988"><g id="Group_4759" data-name="Group 4759" transform="translate(-1100.75 -1225.439)"><path id="Path_328" data-name="Path 328" d="M-16718.3-20603.133l4.934,4.936,4.934-4.936" transform="translate(21715.004 -15481.93) rotate(-90)" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/><line id="Line_287" data-name="Line 287" x1="15.305" transform="translate(1101.5 1231.5)" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-width="1.5"/></g></svg>');


    jQuery('.full-slickslider').slick({
        arrows: true,
         infinite: true,
         speed: 750,
         centerMode: true,
        centerPadding: '212px',
        slidesToShow: 1,  
        responsive: [
            {
              breakpoint: 768,
              settings: {
                arrows: false,
                dots: true
              }
            }
        ]
    });

    jQuery('.newsfeedslide').slick({
        arrows: false,
         infinite: true,
         speed: 750,
         centerMode: true,
        slidesToShow: 3,  
        responsive: [
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1,
                arrows: false,
                dots: true
              }
            }
        ]
    });  


    jQuery('.sliderbits-rev').slick({
        arrows: false,
        infinite: true,
        centerMode: false,
        adaptiveHeight: true,
        slidesToShow: 4,  
        responsive: [
            {
              breakpoint: 768,
              settings: { 
                centerMode: false,
                slidesToShow: 1,
                arrows: false,
                dots: false
              }
            }
        ]
    });

    jQuery('.iconbitsmob').slick({
        dots: true,
        arrows: false,
         infinite: true,
         variableWidth: true,
         speed: 750,
         centerMode: true,
        centerPadding: '20px',
        slidesToShow: 1, 
    });

    jQuery('.teamslida').slick({
        dots: false,
        arrows: true,
         infinite: true,
         variableWidth: true,
         speed: 750,
         centerMode: true,
        centerPadding: '20px',
        slidesToShow: 1, 
    });

    jQuery('.testimslider').each(function() {
        var $thisTesti = jQuery(this);
        jQuery('.testimslider').slick({
            arrows: false,
            dots: true,
            infinite: true,
            speed: 750,
            centerMode: true,
            slidesToShow: 1, 
            appendDots:  $thisTesti.closest('.testimsliderwrap').find('.sliderarrowinsert')
        });
    });

    
    jQuery('.revvyslider').each(function() {
        var $thisTesti = jQuery(this);
        jQuery('.revvyslider').slick({
            arrows: false,
            dots: true,
            infinite: true,
            speed: 750,
            centerMode: false,
            slidesToShow: 1, 
            appendDots:  $thisTesti.closest('.revvywrap').find('.sliderarrowinsert')
        });
    });




    jQuery('.pinglist-slider').each(function() {
        var $thisTesti = jQuery(this);
        $thisTesti.slick({
            arrows: false,
            dots: true,
            infinite: true,
            speed: 750,
            appendDots:  $thisTesti.closest('.newsfeedkee').find('.sliderarrowinsert'),
            centerMode: false,
            slidesToShow: $thisTesti.attr('data-numslides'),  
            responsive: [
                {
                  breakpoint: 768,
                  settings: {
                    slidesToShow: 1,
                    centerMode: true,
                    arrows: false, 
                    dots: true
                  }
                }
            ]
        });
    });


    jQuery('.fullbleed-slider').slick({
        arrows: false,
        infinite: true,
        centerMode: false,
        adaptiveHeight: true,
        slidesToShow: 1
    });


    jQuery('.fullbleed-slider-box').each(function() {
        var $slidbox = jQuery(this);


        $slidbox.closest('.newsfeed-fullbleed').find('.sliderarrowinsert').addClass('rerwerw');

        jQuery(this).slick({
            arrows: false,
            infinite: true,
            centerMode: false,
            dots: true,
            adaptiveHeight: true,
            appendDots:  $slidbox.closest('.newsfeed-fullbleed').find('.sliderarrowinsert'),
            slidesToShow: 1
        });
    });



jQuery(window).on('load', function() {
    if (jQuery('div#sbi_images').length) {
        jQuery('div#sbi_images').slick({
            arrows: false,
            dots: true,
            infinite: true,
            speed: 750,
            appendDots: jQuery('div#sbi_images').closest('.feedblock').find('.sliderarrowinsert'),
            centerMode: false,
            slidesToShow: 4,
            responsive: [{
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    centerMode: true,
                    arrows: false,
                    dots: true
                }
            }]
        });
        jQuery(window).trigger('resize');
    }
});

    

    jQuery('.arr-right').on('click', function() {
        if(jQuery(this).closest('.slick-slider').length) jQuery(this).closest('.slick-slider').slick('next');
        if(jQuery(this).closest('.testimsliderwrap').find('.slick-slider').length) jQuery(this).closest('.testimsliderwrap').find('.slick-slider').slick('next');
        if(jQuery(this).closest('.longslider').find('.slick-slider').length) jQuery(this).closest('.longslider').find('.slick-slider').slick('next');
        if(jQuery(this).closest('.revvywrap').find('.slick-slider').length) jQuery(this).closest('.revvywrap').find('.slick-slider').slick('next');
        if(jQuery(this).closest('.newsfeedkee').find('.slick-slider').length) jQuery(this).closest('.newsfeedkee').find('.slick-slider').slick('next');
        if(jQuery(this).closest('.newsfeed').find('.slick-slider').length) jQuery(this).closest('.newsfeed').find('.slick-slider').slick('next');
        if(jQuery(this).closest('.newsfeed-fullbleed').find('.slick-slider').length) jQuery(this).closest('.newsfeed-fullbleed').find('.slick-slider').slick('next');
        if(jQuery(this).closest('.feedblock').find('.slick-slider').length) jQuery(this).closest('.feedblock').find('.slick-slider').slick('next');

    });
    
    jQuery('.arr-left').on('click', function() {
        if(jQuery(this).closest('.slick-slider').length) jQuery(this).closest('.slick-slider').slick('prev');
        if(jQuery(this).closest('.testimsliderwrap').find('.slick-slider').length) jQuery(this).closest('.testimsliderwrap').find('.slick-slider').slick('prev');
        if(jQuery(this).closest('.longslider').find('.slick-slider').length) jQuery(this).closest('.longslider').find('.slick-slider').slick('prev');
        if(jQuery(this).closest('.revvywrap').find('.slick-slider').length) jQuery(this).closest('.revvywrap').find('.slick-slider').slick('prev');
        if(jQuery(this).closest('.newsfeedkee').find('.slick-slider').length) jQuery(this).closest('.newsfeedkee').find('.slick-slider').slick('prev');
        if(jQuery(this).closest('.newsfeed').find('.slick-slider').length) jQuery(this).closest('.newsfeed').find('.slick-slider').slick('prev');
        if(jQuery(this).closest('.newsfeed-fullbleed').find('.slick-slider').length) jQuery(this).closest('.newsfeed-fullbleed').find('.slick-slider').slick('prev');
        if(jQuery(this).closest('.feedblock').find('.slick-slider').length) jQuery(this).closest('.feedblock').find('.slick-slider').slick('prev');


        
    });


    jQuery('.head-accord-bit').on('click', function() {
        if(jQuery(this).closest('.the-accord').is('.accord-active')) {
            jQuery(this).closest('.the-accord').removeClass('accord-active');
            jQuery(this).closest('.the-accord').find('.body-accord').css('max-height', 0);
        } else {
            jQuery(this).closest('.the-accord').addClass('accord-active');
            jQuery(this).closest('.the-accord').find('.body-accord').css('max-height', jQuery(this).closest('.the-accord').find('.body-accord-inner').outerHeight());
        }
    });


    jQuery('.tabby').on('click', function() {
        var $parent = jQuery(this).closest('.tabberwrap');
        var trget = jQuery(this).attr('data-tabtrigger');
        
        $parent.find('.tabbyactive').removeClass('tabbyactive');
        $parent.find('.tabby[data-tabtrigger="'+trget+'"]').addClass('tabbyactive');
        $parent.find('.tabby-body[data-tabbody="'+trget+'"]').addClass('tabbyactive');
    });

    jQuery('.stickitem').stick_in_parent({
        offset_top: jQuery('#wrapper-navbar').outerHeight()+ 10
        //offset_top: (jQuery(window).height() / 2) - (jQuery('.stickitem').outerHeight() / 2)
    });

});

function updateRelativeHeightBits() {
    jQuery('.image-text-block.bleed-1 .connoimg').each(function() {
        jQuery(this).parent().css('height', jQuery(this).outerHeight());
    });
}

function disableScrolling(){
    var x=window.scrollX;
    var y=window.scrollY;
    window.onscroll=function(){window.scrollTo(x, y);};
}

function enableScrolling(){
    window.onscroll=function(){};
}


jQuery(document).ready(function() {
    updateRelativeHeightBits();
});
 
jQuery(window).resize(function() {
    updateRelativeHeightBits();
});

jQuery(window).on('load', function() { 
    updateRelativeHeightBits(); 
    jQuery('body').addClass('iriewrewi');

    console.log('run rel heights');
});

console.log('rlwqrkkqwr');
 
jQuery('.playico').on('click', function() { 
    jQuery(this).closest('.image-text-block').find('.fkmodal').fadeIn();
    jQuery(this).closest('.vidembed').find('.fkmodal').fadeIn();
    jQuery(this).closest('.vidembed').find('.fkmodal').find('.vjs-big-play-button').click();
    jQuery(this).closest('.image-text-block').find('.fkmodal').find('.vjs-big-play-button').click();
    enableScrolling();
});

jQuery('.ginput_container_consent input[type="checkbox"]').wrap('<div class="cstmtickbox"></div>');

jQuery('.cstmtickbox').append('<div class="fkchecker"><span></span></div>');


jQuery(document).ready(function() {
    if(jQuery('.ginput_container_select').length) {
        jQuery('.ginput_container_select select').selectric();
    }
    if(jQuery('.catblock').length) {
        jQuery('.catblock').selectric();
    }

    
});

jQuery('.ginput_container_fileupload').each(function() {
    jQuery('<div class="thefkinput"><span class="placeholda">ATTACH FILE</span> <div class="thefloaticon"><div class="floatclip"></div></div></div>').insertAfter(jQuery(this).find('input[type="file"]'));
});

jQuery('.cstmtickbox, label.gfield_consent_label').on('click', function() {
    jQuery(this).closest('.ginput_container_consent').find('input').prop("checked", !jQuery(this).closest('.ginput_container_consent').find('input').prop("checked"));
});

jQuery('.ginput_container_fileupload input[type="file"]').bind('change', function() {
    jQuery(this).closest('.ginput_container_fileupload').find(".thefkinput span").html(jQuery(this).val());
    jQuery(this).closest('.ginput_container_fileupload').find(".placeholda").removeClass('placeholda');
});

jQuery('.fkmodal-cross').on('click', function() {
    jQuery(this).closest('.fkmodal').fadeOut();

    if(jQuery(this).closest('.fkmodal').find('video').length) jQuery(this).closest('.fkmodal').find('video').trigger('pause');
    enableScrolling();
});

jQuery('.list-toggler li').on('click', function() {
    var cTarget = jQuery(this).attr('data-listkey');
    jQuery(this).closest('.listandtext').find('.list-toggler .listactive').removeClass('listactive');
    jQuery(this).closest('.listandtext').find('.conto-tab.listactive').removeClass('listactive');
    jQuery(this).closest('.listandtext').find('div[data-listarget="'+cTarget+'"]').addClass('listactive');
    jQuery(this).closest('.listandtext').find('.list-toggler li[data-listkey="'+cTarget+'"]').addClass('listactive');
});



function alignNav() {
    if(!jQuery('.navvy-fixed').length) return false;
    jQuery('body').css('padding-top', jQuery('.navvy-fixed').outerHeight());
}

jQuery(document).ready(function() {
    alignNav();
});
jQuery(window).resize(function() {
    alignNav();
});

jQuery('.cookiebar-inner .btn').on('click', function(e) {
    e.preventDefault();
    Cookies.set('cookies_accepted', '1', { expires: 30 })
    jQuery('.cookiebar').addClass('cookies-hidden');
});

jQuery(document).ready(function() {
    if(!Cookies.get('cookies_accepted')) {
        jQuery('.cookies-hidden').removeClass('cookies-hidden');
    }
});

jQuery('.searchicon a').on('click', function(e) {
    e.preventDefault();
    jQuery('.searchformhead').toggleClass('searchformhead-hidden');
});


jQuery('#main-menu li, #main-menu ul').on('mouseover mouseout', function() {
    var allDroppers = jQuery('.dropdown-menu:visible');

    jQuery('.fotype').removeClass('fotype');
    jQuery('.latype').removeClass('latype');

    allDroppers.css('height', false);

    var maxHeight = -1;
    var len = allDroppers.length;
    allDroppers.each(function(index) {
        if (index === (len - 1)) jQuery(this).addClass('latype');
        if (index === 0) jQuery(this).addClass('fotype');
        maxHeight = maxHeight > jQuery(this).height() ? maxHeight : jQuery(this).height();
    });

    allDroppers.css('height', maxHeight);
    
});

jQuery('.menu-item-has-children.dropdown>a').append('<div class="chevva"><svg xmlns="http://www.w3.org/2000/svg" width="6.404" height="11.308" viewBox="0 0 6.404 11.308"><path id="Path_14684" data-name="Path 14684" d="M0,4.594,4.594,0,9.186,4.594" transform="translate(5.654 1.061) rotate(90)" fill="none" stroke="#3b3c4b" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/></svg></div>');


lightbox.option({
    // 'resizeDuration': 200,
    'wrapAround': true,
    'disableScrolling': true
});

jQuery('.trigpopperup').on('click', function() {
    var $cParent = jQuery(this).closest('.longslider');
    var thisTarget = jQuery(this).attr('data-fkpoptrg');
    $cParent.find('.fkreviewpop[data-fkpopid="'+thisTarget+'"]').fadeIn();    
});

jQuery('.fkreviewpop .exitblocker, .fkreviewpop .personpop-bg').on('click', function() {
      jQuery(this).closest('.fkreviewpop').fadeOut();
});


jQuery('.personimgbit').on('click', function() {
    jQuery(this).closest('.teamfeedwrap').find('.personpop-modal[data-tid="'+jQuery(this).attr('data-trgimg')+'"]').fadeIn();
});

jQuery('.exitblocker').on('click', function() {
    jQuery(this).closest('.teamfeedwrap').find('.personpop-modal').fadeOut();
});


jQuery(document).ready(function() {
    jQuery('body').attr('data-scrollpos', jQuery(window).scrollTop());
});

jQuery(window).scroll(function (event) {
    jQuery('body').attr('data-scrollpos', jQuery(window).scrollTop());
});

jQuery('.subbtn').on('click', function(e) {
    e.preventDefault();
    jQuery(this).closest('form').find('input[type="submit"]').click();
});

jQuery('.catblock').on('change', function() {
    jQuery(this).closest('form').submit();
});



jQuery(window).on('load', function() {
    jQuery('.it-counter').countTo({
        speed: 3000
    });
    AOS.init({
        once: true,
        offset: 200,
        delay: 0,
        duration: 1200,
        easing: 'ease',
    });

    setTimeout(function() {
        AOS.refresh();
    }, 1500);

    if(jQuery('.masonwrap').length) {
        jQuery('.masonwrap').each(function() {
            var $mason = jQuery(this).masonry({
                isInitLayout: false,
                itemSelector: '.masonry-galleryimgbit'
            });
            $mason.masonry( 'on', 'layoutComplete', function() {
                console.log('here');
                AOS.refresh();
            });
            $mason.masonry();
        });
    }
});

document.addEventListener('aos:in', ({ detail }) => {
    console.log('animated in', detail);
  });


var outerContainerSize = 0;
outerContainerSize = (jQuery(window).width() - jQuery('.container')[0].getBoundingClientRect().width) / 2;


// jQuery(window).resize(function() {
//     outerContainerSize = (jQuery(window).width() - jQuery('.container')[0].getBoundingClientRect().width) / 2;
//     jQuery('.bleed-1:not(.imgdirection-flex-row) .connoimg').css('left', -outerContainerSize);
//     jQuery('.bleed-1.imgdirection-flex-row .connoimg').css('right', -outerContainerSize);
// });
 
// jQuery('.bleed-1:not(.imgdirection-flex-row) .connoimg').css('left', -outerContainerSize);
// jQuery('.bleed-1.imgdirection-flex-row .connoimg').css('right', -outerContainerSize);

// console.log(outerContainerSize);



var scrollOffset = 100;

jQuery(window).scroll(function() {


    

  jQuery('.longslider').each(function() {
      //console.log(this+$(this).position().top);
    if (jQuery(window).scrollTop() > jQuery(this).position().top + (scrollOffset - jQuery(this).height())) {
      if (!jQuery(this).hasClass('wpb_start_animation')){
        jQuery(this).addClass('wpb_start_animation');
      }
    }
  });
});


jQuery('div[data-fklink]').on('click', function() {
    if(jQuery(this).attr('data-fklink')) {
        window.location.href = jQuery(this).attr('data-fklink');
    }
});


 
jQuery('.dotsbit button[data-target]').on('click', function(e) {
    e.preventDefault();
    jQuery(this).closest('.slick-slider').slick('slickGoTo', jQuery(this).attr('data-target'));
});


function updatePad() {


    if(!jQuery('body.disablestickynav-1 header#wrapper-navbar').length) return;
    
    var NavHeight = jQuery('body.disablestickynav-1 header#wrapper-navbar').outerHeight();

    jQuery('.hero-headerbit').css('padding-top', NavHeight);
    jQuery('.hero-headerbit').css('padding-bottom', NavHeight);
}

updatePad();

jQuery(window).on('resize', function() {
    updatePad();
});


jQuery("a[href^='http']:not([href*='"+window.location.host+"'])").click(function(){
    window.open(this.href);
    return false;
}).attr("title", "Opens in a new window");



setInterval(function() {
    updatePad();
    updateRelativeHeightBits();
}, 500);


function setHeightsHero() {
    if (jQuery(window).width() < 992) {
        jQuery('.hero-headerbit').css('min-height','');
        jQuery('.hero-headerbit').css('min-height', jQuery('.hero-headerbit').outerHeight());
    } else {
        jQuery('.hero-headerbit').css('min-height','');
    }
    }
    
    jQuery(window).on('load',function() {
        setHeightsHero();
    });
    
    jQuery(window).on('resize', function() {
        setHeightsHero();
    });


// jQuery('.ginput_container_select').append('<label></label>');


// jQuery(window).on('load',function() {
//     if(jQuery('.masonwrap').length) {
//         console.log('run length');
//         jQuery('.masonwrap').each(function() {
//             jQuery(this).masonry('layout');
//         }); 
//     }
//     setTimeout(function() {
//         if(jQuery('.masonwrap').length) {
//             jQuery('.masonwrap').each(function() {
//                 jQuery(this).masonry('layout');
//             });
//         }
//     }, 4500);
// });